export default __webpack_public_path__ + "static/media/icon_Check_.05194422.svg";